

<mat-card class="full-stretch flex-column message-box-card">

    <mat-card-header class="card-header padding-standard border-primary-bottom">
        <mat-card-title *ngIf="title" class="mat-headline-4" >{{title | translate | replace:params.replace}}</mat-card-title>
        <mat-card-subtitle *ngIf="params.subtitle">{{params.subtitle | translate | replace:params.replace}}</mat-card-subtitle>

        <button mat-icon-button (click)="close(undefined)"><mat-icon>close</mat-icon></button>

    </mat-card-header>
    
    <mat-card-content class="flex-1 padding-standard">
        {{params.text | translate | replace:params.replace}}
    </mat-card-content>
    
    <mat-card-footer class="padding-standard border-gray-top">

        <div class="responsive-actions gap-standard padding-none" *ngIf="params.buttons === 'YesNo'" >

            <button (click)="close('No')"  mat-raised-button class="flex-1"> {{no | translate}}</button>
            <button (click)="close('Yes')" mat-raised-button color="primary"  class="flex-1">{{yes | translate}}</button>

        </div>
        
        <ng-container *ngIf="params.buttons === 'Ok'">
            <button 
                class="full-width" 
                (click)="close('Ok')" 
                color="primary" 
                mat-raised-button 
            >
                {{'ss-general.ok' | translate}}
            </button>
        </ng-container>

    </mat-card-footer>
</mat-card>